<template>
  <div :class="['auth-wrapper', _isMobile() ? 'mobile' : '']">
    <div class="login_backgroun">
      <div class="orbit orbit-1"></div>
      <div class="orbit orbit-2"></div>
      <div class="glow"></div>
      <div class="login_content">
        <div class="login_left login_box" v-if="!_isMobile()">
          <div class="left_inner">
            <p class="tag">NEW ACCOUNT</p>
            <h2>
              轻松完成实名认证，<br />
              打开学习与管理新体验
            </h2>
            <p class="desc">
              一次注册即可同步多端数据，审核状态实时可查，保障信息安全与体验感。
            </p>
            <div class="highlights">
              <span>• 实名认证</span>
              <span>• 智能审批</span>
              <span>• 多终端支持</span>
            </div>
          </div>
        </div>
        <div class="login_right login_box">
          <p class="title">注册账号</p>
          <Register />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions } from "vuex";
import { TENANT_CONFIG } from "@/store/mutation-types";
import Register from "../components/user/Register";
import { mixinDevice } from "@/utils/mixin.js";

export default {
  mixins: [mixinDevice],
  components: {
    Register,
  },
  data() {
    return {
    };
  },
  created() {
  },
  mounted() {
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.auth-wrapper {
  min-height: 100vh;
}

.mobile {
  .login_content {
    flex-direction: column;
    width: 92%;
    height: auto;
  }

  .login_right {
    width: 100% !important;
  }
}

.login_backgroun {
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(130deg, #071734, #0f285d 45%, #3c66f5);
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  .glow {
    position: absolute;
    width: 640px;
    height: 640px;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.18), transparent 70%);
    top: 5%;
    left: 12%;
    filter: blur(6px);
    animation: pulse 8s ease-in-out infinite;
  }

  .orbit {
    position: absolute;
    border-radius: 50%;
    border: 1px dashed rgba(255, 255, 255, 0.2);
    animation: spin 20s linear infinite;

    &.orbit-1 {
      width: 780px;
      height: 780px;
      bottom: 12%;
      left: 5%;
    }

    &.orbit-2 {
      width: 460px;
      height: 460px;
      top: 10%;
      right: 18%;
      animation-duration: 26s;
    }
  }

  .login_content {
    position: relative;
    width: 980px;
    height: 560px;
    display: flex;
    gap: 32px;
    z-index: 2;
  }

  .login_box {
    width: 50%;
    height: 100%;
    border-radius: 32px;
    backdrop-filter: blur(10px);
    transition: transform 0.4s ease, box-shadow 0.4s ease;

    &:hover {
      transform: translateY(-6px);
      box-shadow: 0 25px 50px rgba(7, 21, 52, 0.36);
    }

    .title {
      font-size: 20px;
      color: #1f2d3d;
      font-weight: bold;
      margin-bottom: 15px;
    }
  }

  .login_left {
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.12), rgba(255, 255, 255, 0.05));
    border: 1px solid rgba(255, 255, 255, 0.28);
    padding: 42px;
    color: #fff;

    .left_inner {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      animation: slideIn 0.8s ease-out;

      .tag {
        font-size: 12px;
        letter-spacing: 2px;
        text-transform: uppercase;
        color: rgba(255, 255, 255, 0.8);
      }

      h2 {
        font-size: 30px;
        line-height: 1.5;
        margin-top: 10px;
        margin-bottom: 12px;
      }

      .desc {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.82);
      }

      .highlights {
        display: flex;
        gap: 12px;
        flex-wrap: wrap;
        font-size: 13px;
        color: rgba(255, 255, 255, 0.85);
      }
    }
  }

  .login_right {
    background: #fff;
    border-radius: 32px;
    padding: 32px 36px;
    box-shadow: 0 18px 35px rgba(16, 32, 83, 0.25);
  }
}

@keyframes pulse {
  0% {
    transform: scale(0.9);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.05);
    opacity: 1;
  }
  100% {
    transform: scale(0.9);
    opacity: 0.5;
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>